"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangePasswordRequestSchema = exports.NewPasswordSchema = exports.AdminLoginRequestSchema = exports.StaffProfileSchema = exports.StaffRoleSchema = exports.StaffStatusSchema = exports.StaffEmailSchema = void 0;
const zod_1 = require("zod");
const onboarding_1 = require("../onboarding");
exports.StaffEmailSchema = zod_1.z.string().transform(onboarding_1.normaliseEmail).pipe(zod_1.z.email().max(254));
exports.StaffStatusSchema = zod_1.z.enum(['active', 'disabled']);
/** Spec 2026-10-28 staff roles: `admin` reaches everything, `support` works tickets and a scoped view. */
exports.StaffRoleSchema = zod_1.z.enum(['admin', 'support']);
exports.StaffProfileSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    email: zod_1.z.string(),
    name: zod_1.z.string(),
    status: exports.StaffStatusSchema,
    role: exports.StaffRoleSchema,
    mustChangePassword: zod_1.z.boolean(),
    lastLoginAt: zod_1.z.iso.datetime().nullable(),
    createdAt: zod_1.z.iso.datetime(),
});
exports.AdminLoginRequestSchema = zod_1.z.object({
    email: exports.StaffEmailSchema,
    password: zod_1.z.string().min(1).max(128),
});
/** Spec 4: at least 12 characters, at most 128, no other composition rules. */
exports.NewPasswordSchema = zod_1.z.string().min(12).max(128);
exports.ChangePasswordRequestSchema = zod_1.z.object({
    currentPassword: zod_1.z.string().min(1).max(128),
    newPassword: exports.NewPasswordSchema,
});
//# sourceMappingURL=auth.js.map